/* src/app/ship/components/request-quote-dialog/request-quote-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ups-dialog {
  padding-bottom: 1rem;
}
.ups-dialog .dialog-header {
  background-color: #f0f0ef;
  padding: 2.4375rem 3rem 0 3rem;
}
.ups-dialog .mat-mdc-dialog-content {
  padding: 0;
}
.ups-dialog .main-content .message,
.ups-dialog .main-content ul.benefits {
  background-color: #f0f0ef;
  padding: 0 3rem;
}
.ups-dialog .main-content .message {
  font-size: 0.9rem;
  color: #404040;
}
.ups-dialog .main-content ul.benefits {
  list-style-type: none;
  padding: 1rem 3rem;
}
.ups-dialog .main-content ul.benefits li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1rem;
  font-weight: 700;
  line-height: 2;
}
.ups-dialog .main-content ul.benefits li .mat-icon {
  font-weight: 500;
  line-height: 1;
  margin-right: 1rem;
}
.ups-dialog .main-content .mat-mdc-dialog-content {
  padding: 0;
}
.ups-dialog .main-content form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1rem 3rem;
  position: relative;
}
.ups-dialog .main-content form .name {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .ups-dialog .main-content form .name {
    flex-direction: row;
    justify-content: space-between;
  }
  .ups-dialog .main-content form .name .mat-mdc-form-field {
    flex: 0 1 48%;
  }
}
.ups-dialog .main-content form .error-message {
  font-size: 0.8rem;
  line-height: 1;
}
.ups-dialog .main-content form button[type=submit] {
  margin: 1rem auto;
  padding: 0 5rem;
}
.ups-dialog .main-content .agreement {
  text-align: center;
  font-size: 0.6875rem;
  color: #6e6e6e;
}
.ups-dialog .notification {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  padding: 2rem;
}
.ups-dialog .notification .title {
  font-size: 1.75rem;
  font-weight: 700;
}
.ups-dialog .notification .message {
  font-size: 1rem;
  color: #6e6e6e;
}
.ups-dialog .notification button {
  margin: 2rem auto 0;
  padding: 0 8rem;
}
/*# sourceMappingURL=request-quote-dialog.component.css.map */
